import { Routes } from '@angular/router';
import { nonProfitOrganizationsType01Component } from './non-profit-organizations-type01/non-profit-organizations-type01.component';

export default [
    {
        path     : '',
        component: nonProfitOrganizationsType01Component,
    },
    
] as Routes;
